import { render } from "./Vevo.vue?vue&type=template&id=80f01aaa&scoped=true&ts=true"
import script from "./Vevo.vue?vue&type=script&lang=ts"
export * from "./Vevo.vue?vue&type=script&lang=ts"

import "./Vevo.vue?vue&type=style&index=0&id=80f01aaa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80f01aaa"]])

export default __exports__